import { useMemo } from "react";
import RunwayProjectionChart from "@/components/charts/RunwayProjectionChart";
import {
  getLandingSampleChartData,
  LANDING_SAMPLE_VISIBLE_RANGE,
} from "@/content/landing-sample-data";
import { ProductPreviewFrame } from "./ProductPreviewFrame";

type LandingProductPreviewProps = {
  className?: string;
};

export function LandingProductPreview({ className = "" }: LandingProductPreviewProps) {
  const data = useMemo(() => getLandingSampleChartData(), []);

  return (
    <ProductPreviewFrame title="Runway projection" className={className}>
      <div className="p-4">
        <RunwayProjectionChart
          data={data as Parameters<typeof RunwayProjectionChart>[0]["data"]}
          visibleDateRange={LANDING_SAMPLE_VISIBLE_RANGE}
          height={280}
        />
      </div>
    </ProductPreviewFrame>
  );
}
